import React from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import GlobalAdminSoundAlert from "@/components/GlobalAdminSoundAlert";

interface AdminLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

export function AdminLayout({ children, title, description }: AdminLayoutProps) {
  return (
    <AdminLayoutContent title={title} description={description}>
      {children}
    </AdminLayoutContent>
  );
}

function AdminLayoutContent({ children, title, description }: AdminLayoutProps) {
  return (
    <SidebarProvider>
      <GlobalAdminSoundAlert />
      
      <div className="min-h-screen flex w-full bg-background">
        <AdminSidebar />
        
        <div className="flex-1 flex flex-col">
          {/* Main Content */}
          <main className="flex-1 overflow-auto">
            <div className="p-4 md:p-6">
              {children}
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}